import type { Meta } from '@ps/web-martech-cms-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import sharedStyles from '../../styles/styles.scss';
import CMSLink from '../CMSLink/CMSLink';
import CMSPreloadImage from '../CMSPreloadImage/CMSPreloadImage';

import styles from './CMSBanner.scss';

const CMSBanner: React.FC<Meta['banner']> = ({
  variant,
  linked_image: linkedImage,
  mobile_image: mobileImage
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const desktopImageUrl = linkedImage?.image?.asset?.url;
  const mobileImageUrl = mobileImage?.image?.asset?.url;

  if (!desktopImageUrl && !mobileImageUrl) {
    return null;
  }

  const imageUrl = isMobile ? mobileImageUrl || desktopImageUrl : desktopImageUrl || mobileImageUrl;

  const imgContainer = <div style={getBackgroundImageStyle(imageUrl)} className={styles.banner} />;

  return (
    <>
      {imageUrl && <CMSPreloadImage imageUrl={imageUrl} />}
      <div className={sharedStyles[variant as keyof typeof sharedStyles]}>
        {linkedImage.link.url ? (
          <CMSLink {...linkedImage.link}>{imgContainer}</CMSLink>
        ) : (
          imgContainer
        )}
      </div>
    </>
  );
};

export default CMSBanner;
